import { useCallback, useRef } from 'react';

const defaultOptions = { throttle: false };

export function useDebouncedCallback(fn, dependencies, wait, options = defaultOptions) {
  const { throttle } = options;
  const timeout = useRef(null);
  return useCallback((...args) => {
    args.forEach((arg) => {
      if (!!arg.persist) {
        arg.persist();
      }
    });
    if (throttle) {
      if (timeout.current === null) {
        fn(...args);
        timeout.current = setTimeout(() => {
          timeout.current = null;
        }, wait);
      }
    } else {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        fn(...args);
      }, wait);
    }
  }, dependencies);
}
